import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Register from './components/Register';
import ContractorView from './components/ContractorView';
import ConcessionaireView from './components/ConcessionaireView';
import AdminDashboard from './components/AdminDashboard';
import RequestManagementView from './components/RequestManagementView'; // <-- Nuevo componente
import './App.css';

const API_BASE_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3000';

// Definición de pestañas por rol
const TABS_BY_ROLE = {
  Contratista: ['Generar OT', 'Mis Solicitudes', 'Ver Stock'],
  Concesionario: ['Gestión de Stock', 'Requerimientos', 'Auditoría'],
  Administrador: ['Usuarios', 'Auditoría'],
};

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [showRegister, setShowRegister] = useState(false);
  const [activeTab, setActiveTab] = useState('');

  useEffect(() => {
    if (!token) {
      setUser(null);
      setActiveTab('');
    }
  }, [token]);

  useEffect(() => {
    if (user && TABS_BY_ROLE[user.role]) {
      setActiveTab(TABS_BY_ROLE[user.role][0]); // Seleccionar la primera pestaña por defecto
    }
  }, [user]);

  const handleLogin = (loggedInUser, receivedToken) => {
    setUser(loggedInUser);
    setToken(receivedToken);
    localStorage.setItem('token', receivedToken);
  };

  const handleLogout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('token');
  };

  if (!token) {
    return showRegister ? <Register onBackToLogin={() => setShowRegister(false)} /> : <Login onLogin={handleLogin} onShowRegister={() => setShowRegister(true)} />;
  }

  const renderContent = () => {
    if (!user || !activeTab) return null;

    const commonProps = { apiUrl: API_BASE_URL, token };

    switch (user.role) {
      case 'Contratista':
        return <ContractorView {...commonProps} activeTab={activeTab} />;
      case 'Concesionario':
        if (activeTab === 'Requerimientos') {
          return <RequestManagementView {...commonProps} />;
        }
        return <ConcessionaireView {...commonProps} activeTab={activeTab} />;
      case 'Administrador':
        return <AdminDashboard {...commonProps} />;
      default:
        return <div>Rol no reconocido.</div>;
    }
  };

  return (
    <div className="App">
      <nav className="navbar">
        <div className="navbar-top">
          <div className="navbar-brand">
            <h1>Gestión de Mantenimiento</h1>
          </div>
          <div className="navbar-user">
            <span>{user ? `${user.email} (${user.role})` : 'Cargando...'}</span>
            <button onClick={handleLogout} className="logout-link">Cerrar Sesión</button>
          </div>
        </div>
        {user && TABS_BY_ROLE[user.role] && (
          <div className="navbar-tabs">
            {TABS_BY_ROLE[user.role].map(tab => (
              <button
                key={tab}
                className={`nav-tab ${activeTab === tab ? 'active' : ''}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        )}
      </nav>
      
      <main className="main-content">
        <div className="view-container">
          {renderContent()}
        </div>
      </main>
    </div>
  );
}

export default App;